import http from './httpService';

const endPoint = "/Contracts";

export function getStats(statusId) {
	return http.get(`${endPoint}/GetCountByStatus/?contractStatusId=${statusId}`);
}

export function getContracts(statusId, take, skip) {
	return http.get(
		`${endPoint}/GetAllByStatus?contractStatusId=${statusId}&take=${take}&skip=${skip}`
	);
}

export function getContractsByClient(clientId, statusId) {
	return http.get(`${endPoint}/GetByClient`, { params: { clientId, statusId } });
}

export function getContract(contractId) {
	return http.get(`${endPoint}/${contractId}`);
}

export function createContract(contract) {
	return http.post(`Contracts`, contract);
}

export function cancelContract(contractId, comments) {
	return http.patch(`${endPoint}/Cancel/${contractId}`, {
		comments,
	});
}

export function reActivateContract(contractId, salesOfficeId) {
	return http.patch(`${endPoint}/ReActivate/${contractId}`, { salesOfficeId });
}

export function suspendContract(newSuspension) {
	return http.post(`${endPoint}/${newSuspension.contractId}/Suspensions`, {
		...newSuspension,
		contractStatusId: "SUS."
	});
}

export function installContract(contractId, request) {
	return http.patch(`${endPoint}/Install/${contractId}`, request);
}

export function approveInstallation(contractId, request) {
	return http.patch(`${endPoint}/ApproveInstallation/${contractId}`, request);
}

export function rejectInstallation(contractId, comments) {
	return http.patch(`${endPoint}/RejectInstallation/${contractId}`, {comments});
}

export function update(contractId, contract) {
	return http.patch(`${endPoint}/Update/${contractId}`, contract);
}

export function getHistory(contractId) {
	return http.get(`${endPoint}/${contractId}/StatusHistory`);
}

export function getSuspensions(contractId, positionId){
	return http.get(`${endPoint}/${contractId}/Position/${positionId}/LayOffs`);
}

export function deleteSuspension(contractId, positionId, code) {
	return http.delete(`${endPoint}/${contractId}/Position/${positionId}/LayOff/${code}`)
}

export function checkFutureLayOffs(contracts) {
	return http.post(`${endPoint}/CheckFutureLayOffs`, contracts);
}

export function getCharacteristics(contractId) {
	return http.get(`${endPoint}/${contractId}/Characteristics`);
}

export function statsByStatus() {
	return http.get(`${endPoint}/StatsByStatus`);
}

const contractService = {
	cancelContract,
	checkFutureLayOffs,
	createContract,
	deleteSuspension,
	getCharacteristics,
	getContract,
	getContracts,
	getContractsByClient,
	getHistory,
	getStats,
	getSuspensions,
	installContract,
	reActivateContract,
	statsByStatus,
	suspendContract,
	update
};

export default contractService;